import styled from 'styled-components';
import { Text14Bold } from '../utils/Text/Text.styles';

export const Container = styled.div`
  width: 40rem;
  height: 5.8rem;
  border-radius: 12px;
  border: 1px #f3f4f6;
  background: #fff;
  padding: 0.8rem;
  position: absolute;
  z-index: 1000;
  bottom: 3.5rem;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const RightContent = styled.div`
  display: flex;
  align-items: center;
  gap: 1.2rem;
`;

export const AddButton = styled.button`
  border-radius: 12px;
  border: 1px solid #61ade9;
  background: linear-gradient(93deg, #3e9be4 6.75%, #1672ba 93.25%);
  width: 8rem;
  height: 4.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 1.6rem;
  font-weight: 400;
  letter-spacing: -0.42px;
`;

export const UnselectText = styled(Text14Bold)`
  letter-spacing: -0.42px;
  text-decoration-line: underline;
  cursor: pointer;
  color: #1672ba;
`;
